/*jshint -W087 */
if ((typeof theme) === 'undefined') { theme = {}; }

theme.mfpOpen  = function (popup) {
    var closeBtn = '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp"><i class="icon icon--close"></i></button>';

    switch (popup) {
        case 'password':
            $.magnificPopup.open({
                items: {
                    src: '.js-password-pop'
                },
                type: 'inline',
                mainClass: 'mfp-medium',
                fixedContentPos: true,
                focus: '.js-password-input',
                closeMarkup: closeBtn,
                removalDelay: 200
            }); 
            break;
    }
};

$(document).ready(function(){
    $(document).on('click', '.js-password-pop-trigger', function(e) {
        theme.mfpOpen('password');
        e.preventDefault();
    });
});

/* WYF holding waitlist: email only (name/DOB optional in Klaviyo, hidden here) */
(function () {
  function tidy(root) {
    if (!root) return;
    var rows = root.querySelectorAll('[data-testid="form-row"]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('.klaviyo-form-image, .klaviyo-textinput, input[placeholder="MM/DD/YYYY"], input[placeholder="First Name"], input[placeholder="Last Name"]')) {
        row.classList.add('wyf-hold-hide');
      }
    }
    var email = root.querySelector('input[type="email"]');
    if (email) email.placeholder = 'email';
    var btn = root.querySelector('.klaviyo-form-button');
    if (btn && btn.getAttribute('data-wyf-quiet') !== '1') {
      btn.setAttribute('data-wyf-quiet', '1');
      btn.setAttribute('aria-label', 'Subscribe');
      btn.textContent = '\u2192';
    }
  }
  function run() {
    tidy(document.querySelector('.klaviyo-form-V3FJtc'));
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  var n = 0;
  var t = setInterval(function () {
    run();
    n += 1;
    if (n > 40) clearInterval(t);
  }, 250);
})();
